module.exports = __webpack_public_path__ + "img/20200607_191140.17e3d4a6.jpg";